import React from 'react';
import styled from '@emotion/styled';
import { Section, size } from '@argo/principles';
import { LinkList, Heading } from '@argo/ui-elements';
import { kbbBaseUrl } from '../../constants/config';

const StyledSection = styled(Section)`
  padding-top: ${size.lg}px;
`;

const StyledHeading = styled(Heading)`
  margin-bottom: ${size.lg}px;
`;

export default function ShopPrivateSellerCarsByPriceSection() {
  const links = [
    { name: 'Cars for Sale by Owner Under $1,000', href: `${kbbBaseUrl}/cars-for-sale/used/by-owner/cars-under-1000` },
    { name: 'Cars for Sale by Owner Under $2,000', href: `${kbbBaseUrl}/cars-for-sale/used/by-owner/cars-under-2000` },
    { name: 'Cars for Sale by Owner Under $5,000', href: `${kbbBaseUrl}/cars-for-sale/used/by-owner/cars-under-5000` },
    { name: 'Cars for Sale by Owner Under $10,000', href: `${kbbBaseUrl}/cars-for-sale/used/by-owner/cars-under-10000` },
    { name: 'Cars for Sale by Owner Under $15,000', href: `${kbbBaseUrl}/cars-for-sale/used/by-owner/cars-under-15000` },
    { name: 'Cars for Sale by Owner Under $20,000', href: `${kbbBaseUrl}/cars-for-sale/used/by-owner/cars-under-20000` },
    { name: 'Cars for Sale by Owner Under $25,000', href: `${kbbBaseUrl}/cars-for-sale/used/by-owner/cars-under-25000` },
    { name: 'Cars for Sale by Owner Under $30,000', href: `${kbbBaseUrl}/cars-for-sale/used/by-owner/cars-under-30000` },
  ];

  return (
    <StyledSection data-testid="shop-private-seller-cars-by-price-section">
      <StyledHeading enableTitleCase={false} headingName="SectionHeading" headingTag="h2">Shop Private Seller Cars by Price</StyledHeading>
      <LinkList
        columnCount={
          {
            sm: '1', md: '2', lg: '3', xl: '4', max: '4',
          }
        }
        links={links}
        linkType="regular"
        listType="default"
        typography="body"
        withinParagraph={false}
      />
    </StyledSection>
  );
}
